import "./Range.scss";
import Slider, { Range } from "rc-slider";
import { addCommas } from "@persian-tools/persian-tools";
import { BsCheckCircleFill } from "react-icons/bs";
import { BiLoader } from "react-icons/bi";
export default function Range1({ range, setRange }) {
  console.log("range.range", range.range);
  return (
    <>
      {range.range.length > 0 ? (
        <div className="d-flex flex-column range-style mt-1">
          <div className="box-range">
            <div className=" d-flex flex-column  item-input">
              <div className="">
                <div className="d-flex parent-rang justify-content-evenly">
                  {[...range.range].map((value, index) => {
                    if (index < 3) {
                      return (
                        <div className={`text-center `} key={index}>
                          <div style={{ height: "22px" }}>
                            {value.is_active == "0" &&
                              +value.saled_count == +value.to_count && (
                                <BsCheckCircleFill
                                  style={{ color: "green" }}
                                ></BsCheckCircleFill>
                              )}
                            {value.is_active == "1" &&
                              +value.saled_count < +value.to_count && (
                                <BiLoader style={{ color: "green" }}></BiLoader>
                              )}
                          </div>

                          <div className="rangStart">{value.from_count}</div>
                          <div className="rangEnd">{value.to_count}</div>
                          <div className="priceRangStart">
                            {addCommas(value.from_price)}&nbsp; ت
                          </div>

                          {/* <div className="priceRangEnd">
                            {addCommas(value.to_price)}
                          </div> */}

                          <Slider
                            style={{ marginTop: "10px" }}
                            type="range"
                            min={+value.from_count}
                            max={+value.to_count}
                            // value={priceValue}
                            step={+value.step}
                            reverse
                            value={+value.saled_count + +value.from_count}
                            // onChange={(value) => {
                            //   setRange((prev) => {
                            //     let prv = [...prev];
                            //     prv[index].priceRange = [...value];
                            //     return prv;
                            //     // return { ...prev, priceRange: [...value] };
                            //   });
                            // }}
                          />
                          <div></div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
